import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { openInNewTab } from '@app/common';
import { KeyValuePair } from '@app/models/key-value.model';
import { MessageFile } from '../../../models/message.model';

@Component({
  selector: 'app-chat-doc',
  templateUrl: './chat-doc.component.html',
  styleUrls: ['./chat-doc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChatDocComponent {
  doc = input.required<MessageFile>();

  docType = computed<string>(() => this.getTypeofDoc());
  size = computed<number>(() => this.doc().size / (1024 * 1024));

  readonly docsConfig: KeyValuePair<string> = {
    pdf: 'picture_as_pdf',
    word: 'article',
    excel: 'table_chart',
    text: 'description',
    unknown: 'file_present'
  };

  private getTypeofDoc(): string {
    const { content_type: contentType } = this.doc();
    if (contentType.endsWith('document') || contentType.endsWith('msword')) {
      return 'word';
    } else if (contentType.endsWith('plain')) {
      return 'text';
    } else if (contentType.endsWith('sheet') || contentType.endsWith('ms-excel')) {
      return 'excel';
    } else if (contentType.endsWith('pdf')) {
      return 'pdf';
    }

    return 'unknown';
  }

  downloadDocument(): void {
    openInNewTab(this.doc().file);
  }
}
